(() => {
  /**
   * Cart Pop Up
   * 
   * Emit custom event 'addToCart' and including the following values on detail property
   * @prop {string} title product title
   * @prop {{ src: String, alt: String }} image image object - src prop required, alt prop option
   * @prop {string[]} meta array of meta values. Limit 3
   * @prop {string} unitPrice unit price of product added
   * @prop {string} totalPrice total price of line item added (required)
   * @prop {string | number} cartQuantity total quantity in cart (option)
   */
  const CartPopUp = {
    // Properties
    timeoutId: null,
    cartPopUpEl: document.querySelector('.cart-pop-up'),
    exitEl: document.querySelector('.cart-pop-up__exit'),
    imageEl: document.querySelector('.cart-pop-up__img'),
    titleEl: document.querySelector('.cart-pop-up__title'),
    metaEl: document.querySelector('.cart-pop-up__meta'),
    unitPriceEl: document.querySelector('.cart-pop-up__unit-price'),
    totalPriceEl: document.querySelector('.cart-pop-up__total-price'),
    quantityEl: document.querySelector('.cart-pop-up__quantity'),
    continueEl: document.querySelector('.cart-pop-up__continue'),

    // Methods
    openModal: function () {
      this.cartPopUpEl.classList.remove('pointer-events-none')
      this.cartPopUpEl.classList.remove('opacity-0')
    },
    closeModal: function () {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }

      this.cartPopUpEl.classList.add('pointer-events-none')
      this.cartPopUpEl.classList.add('opacity-0')
    },
    handleAddToCart: function ({ title, image, meta = [], unitPrice, totalPrice, cartQuantity = 0 }) {
      // Image setup
      this.imageEl.setAttribute('src', image.src)
      this.imageEl.setAttribute('alt', image.alt || title)

      // Text content
      this.titleEl.textContent = title || ''
      this.unitPriceEl.textContent = unitPrice || ''
      this.totalPriceEl.textContent = totalPrice
      this.quantityEl.textContent = cartQuantity ? `(${cartQuantity})` : ''

      // Meta values
      this.metaEl.textContent = meta.join(' | ')

      // Open modal
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }

      this.openModal()
      this.timeoutId = setTimeout(() => {
        this.closeModal()
      }, 8000)
    },
    init: function () {
      document.addEventListener('addToCart', (e) => { this.handleAddToCart(e.detail) })
      this.exitEl.addEventListener('click', () => { this.closeModal() })
      this.continueEl.addEventListener('click', () => { this.closeModal() })
    },
  }

  CartPopUp.init()
})()